module.exports = __webpack_public_path__ + "img/background.5d8217d0.jpg";